if (!customElements.get('extend-gallery')) {
  customElements.define('extend-gallery', class ExtendGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        staticThumbnails: this.querySelector('[id^="GalleryStatic"]'),
        staticViewer: this.querySelector('[id^="StaticViewer"]'),
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this,"viewer"), 500));
        if (this.elements.staticViewer != undefined) {
           this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this,"static"), 500));
        }
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch
          .querySelector('button')
          .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, "viewer"));
      });
      if (this.elements.staticThumbnails != undefined) {
          this.elements.staticThumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch
          .querySelector('button')
          .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false), "static");
      });
      }
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    reInit() {
        this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        staticThumbnails: this.querySelector('[id^="GalleryStatic"]'),
        staticViewer: this.querySelector('[id^="StaticViewer"]'),
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;
        this.elements.viewer.classList.remove("hidden");
      if (this.elements.staticViewer != undefined) {
        this.elements.staticViewer.classList.add("hidden");
      }
      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch
          .querySelector('button')
          .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false,  "viewer"));
      });
      if (this.elements.staticThumbnails != undefined) {
          this.elements.staticThumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch
          .querySelector('button')
          .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, "static"));
      });
      }
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event, mode) {
      let thumbnail = null;
      if (mode == "viewer") {
        thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
      } else {
        thumbnail = this.elements.staticThumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
      }
      this.setActiveThumbnail(thumbnail, mode);
    }

    setActiveMedia(mediaId, prepend, mode) {
      let viewers = this.elements.viewer;
      let thumbnails = this.elements.thumbnails;
      if (mode == "static") {
        viewers = this.elements.staticViewer;
        thumbnails = this.elements.staticThumbnails;
      }
      const activeMedia = viewers.querySelector(`[data-media-id="${mediaId}"]`);
      viewers.querySelectorAll('[data-media-id]').forEach((element) => {
        element.removeAttribute('open');
      });
      activeMedia.setAttribute('open', true);

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (thumbnails) {
          const activeThumbnail = thumbnails.querySelector(`[data-target="${mediaId}"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (viewers.slider) viewers.resetPages();
      }
  if (mode == "static") {
     if (this.elements.staticViewer != null) {
        this.elements.staticViewer.classList.remove("hidden");
     }
        this.elements.viewer.classList.add("hidden");

      } else {
          this.elements.viewer.classList.remove("hidden");
          if (this.elements.staticViewer != null) {
            this.elements.staticViewer.classList.add("hidden");
          }
      }
      this.preventStickyHeader();
      window.setTimeout(() => {
        if (thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      });
      this.playActiveMedia(activeMedia);

      if (!thumbnails) return;
      const activeThumbnail = thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail, mode) {
      if (mode == "viewer") {
         if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      } else {
         if (!this.elements.staticThumbnails || !thumbnail) return;

      this.elements.staticThumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.staticThumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.staticThumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
     
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}